/**
 * Close behaviour.
 */

(function (Drupal, $) {
  "use strict";

  /**
   * JS Behaviour.
   *
   * @type {{attach: Drupal.behaviors.sitealert.attach}}
   */
  Drupal.behaviors.sitealert = {
    attach: function (context, settings) {
      $('.alert-level-site').once('alert', function () {
        var throttledPageAlert = _.throttle(Drupal.showPageAlert, 200);
        Drupal.showPageAlert();

        $(window).on('resize', function () {
          throttledPageAlert();
        });
      });
    }
  };

  /**
   * Shows Site level alert and adjusts header components to fit it
   */
  Drupal.showPageAlert = function () {
    var padding = $('.alert-level-site').css('height', 'auto').outerHeight();
    $('body > div.wrapper').css('padding-top', padding);
    $('.main-header-container').css('top', padding);
  };

})(Drupal, jQuery);
